import { LoginCredentials } from '../../models/api-client';
import { LoginVm } from './viewModel';

const createLoginVm = (): LoginVm => ({
  username: '',
  password: '',
});

const mapLoginDtoToLoginVm = (login: LoginCredentials): LoginVm => ({
  username: login.username,
  password: login.password,
});


const mapLoginVmToLoginDto = (login: LoginVm): LoginCredentials => ({
  username: login.username,
  password: login.password,
}) as LoginCredentials;

export default {
  createLoginVm,
  mapLoginDtoToLoginVm,
  mapLoginVmToLoginDto,
};
